<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow: auto;">
            <div id="ObererBereich">
                <h2>{{ $t('athletereleases.Header') }}</h2>
                <div id="GridSportler">
                    <h3>{{ $t('athletereleases.HeaderOverview') }}</h3>
                    <Grid ref="gridSportler"
                          :style="{ height: '300px' }"
                          :data-items="gridDataComputed"
                          :loader="loader"
                          :selected-field="selectedField"
                          @rowclick="onRowClicked"
                          :columns="columns">
                        <grid-norecords>{{ $t('athletereleases.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
            </div>
            <div id="UntererBereich" class="flexContainerRowSB">
                <div id="LinkerBereich">
                    <h3>{{ $t('athletereleases.HeaderAthletereleases') }}</h3>
                    <Grid ref="gridSportlerfreigaben"
                          :style="{ height: '300px' }"
                          :data-items="gridDataComputedSportlerfreigaben"
                          :loader="loaderSportlerfreigaben"
                          :selected-field="selectedFieldSportlerfreigaben"
                          @rowclick="onRowClickedSportlerfreigaben"
                          :columns="columnsSportlerfreigaben">
                        <grid-toolbar>
                            <kbutton title="Loeschen" :theme-color="'primary'" @click="onLoeschenClick">
                                {{ $t('athletereleases.ButtonDelete') }}
                            </kbutton>
                        </grid-toolbar>
                        <grid-norecords>{{ $t('athletereleases.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div id="RechterBereich">
                    <h3>{{ $t('athletereleases.HeaderClubs') }}</h3>
                    <Grid ref="gridVereine"
                          :style="{ height: '300px' }"
                          :data-items="gridDataComputedVereine"
                          :loader="loaderVereine"
                          :selected-field="selectedFieldVereine"
                          @rowclick="onRowClickedVereine"
                          :columns="columnsVereine">
                        <grid-toolbar>
                            <kbutton title="Hinzufuegen" :theme-color="'primary'" @click="onHinzufuegenClick">
                                {{ $t('athletereleases.ButtonAdd') }}
                            </kbutton>
                            <KTextBox :value="filterValue"
                                              @change="filterChange"
                                              style="width:315px"
                                              :placeholder="$t('athletereleases.FilterClassesPlaceholder')">
                            </KTextBox>
                        </grid-toolbar>
                        <grid-norecords>{{ $t('athletereleases.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
            </div>
            <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
                <Fade :appear="success">
                    <Notification v-if="success" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('athletereleases.NotificationSave') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="error">
                    <Notification v-if="error" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('athletereleases.NotificationError') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </div>
    </div>
</template>

<script>
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { TextBox as KTextBox } from "@progress/kendo-vue-inputs";
    import config from "@/appdata/config.json";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'combobox': ComboBox,
            kbutton: Button,
            KTextBox,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                refVereine: 0,
                baseUrl: '',
                baseUrlSportlerfreigben: '',
                baseUrlVereine: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridData: [],
                gridDataSportlerfreigaben: [],
                gridDataVereine: [],
                filteredGridDataVereine: [],
                updatedData: [],
                selectedField: "selected",
                selectedFieldSportlerfreigaben: "selectedSportlerfreigaben",
                selectedFieldVereine: "selectedVereine",
                selectedPrim: 0,
                selectedPrimSportlerfreigaben: 0,
                selectedPrimVereine: 0,
                posturlHinzufuegen: '',
                deleteurlLoeschen: '',
                columns: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderFirstName') },
                    { field: "geburtsdatum", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderDateOfBirth') },
                    { field: "geschlecht", editable: false, width: 100, title: this.$t('athletemanagement.GridColumnHeaderGender') },
                    { field: "graduierung", editable: false, width: 120, title: this.$t('athletemanagement.GridColumnHeaderGraduation') },
                    { field: "paraklasse", editable: false, width: 100, title: this.$t('athletemanagement.GridColumnHeaderParaClass') },
                    { field: "kadermitglied", editable: false, width: 130, title: this.$t('athletemanagement.GridColumnHeaderSquadMember') }
                ],
                columnsSportlerfreigaben: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "refVereine", editable: false, hidden: true, width: 100, title: "refVereine" },
                    { field: "nameStadtVerein", editable: false, width: 400, title: this.$t('athletemanagement.GridColumnHeaderName') },
                ],
                columnsVereine: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "nameStadtVerein", editable: false, width: 400, title: this.$t('athletemanagement.GridColumnHeaderName') },
                ],
                loader: false,
                loaderSportlerfreigaben: false,
                loaderVereine: false,
                success: false,
                error: false,
                forceComputedUpdatex1: null,
                forceComputedUpdatex2: null,
                forceComputedUpdatex3: null
            };
        },
        computed: {
            gridDataComputed() {
                return this.gridData.map((item) => ({ prim: item.prim, name: item.name, vorname: item.vorname, geburtsdatum: item.geburtsdatum, geschlecht: item.geschlecht, graduierung: item.graduierung, paraklasse: item.paraklasse, kadermitglied: item.kadermitglied, selected: (item.prim === this.selectedPrim) }));
            },
            gridDataComputedSportlerfreigaben() {
                return this.gridDataSportlerfreigaben.map((item) => ({ prim: item.prim, refVereine: item.refVereine, nameStadtVerein: item.nameStadtVerein, selectedSportlerfreigaben: (item.refVereine === this.selectedPrimSportlerfreigaben) }));
            },
            gridDataComputedVereine() {
                return this.filteredGridDataVereine.map((item) => ({ prim: item.prim, nameStadtVerein: item.nameStadtVerein, selectedVereine: (item.prim === this.selectedPrimVereine) }));
            }
        },
        created: function () {
            this.refVereine = store.primVerein;
            this.baseUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerJeVereinManagement?RefVereine=" + this.refVereine;
            this.baseUrlVereine = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineAndereManagement?RefVereine=" + this.refVereine;
            this.getData();
            this.getDataVereine();
        },
        methods: {
            onHinzufuegenClick() {
                const parameters = {
                    "refTeilnehmer": this.selectedPrim,
                    "refVereine": this.selectedPrimVereine,
                };
                this.posturlHinzufuegen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerFreigegeben"
                axios.post(this.posturlHinzufuegen, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        //this.showNotificationSuccess();
                        //Reload GridSportlerfreigaben
                        this.gridDataSportlerfreigaben = [];
                        this.baseUrlSportlerfreigaben = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerFreigegebenManagement?RefTeilnehmer=" + this.selectedPrim;
                        this.getDataSportlerfreigaben();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            onLoeschenClick() {
                this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeilnehmerFreigegeben"
                axios.delete(this.deleteurlLoeschen, { data: { refTeilnehmer: this.selectedPrim, refVereine: this.selectedPrimSportlerfreigaben } })
                    .then((response) => {
                        console.log("----------> success", response);
                        //this.showNotificationSuccess();
                        //Reload GridSportlerfreigaben
                        this.gridDataSportlerfreigaben = [];
                        this.baseUrlSportlerfreigaben = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerFreigegebenManagement?RefTeilnehmer=" + this.selectedPrim;
                        this.getDataSportlerfreigaben();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            onRowClicked(event) {
                this.selectedPrim = event.dataItem.prim;
                if (this.selectedPrim > 0) {
                    this.gridDataSportlerfreigaben = [];
                    this.baseUrlSportlerfreigaben = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerFreigegebenManagement?RefTeilnehmer=" + this.selectedPrim;
                    this.getDataSportlerfreigaben();
                } else {
                    this.gridDataSportlerfreigaben = [];
                }
            },
            onRowClickedSportlerfreigaben(event) {
                this.selectedPrimSportlerfreigaben = event.dataItem.refVereine;
            },
            onRowClickedVereine(event) {
                this.selectedPrimVereine = event.dataItem.prim;
            },
            getData: function (initial) {
                this.forceComputedUpdatex1 = null;
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex1 = new Date().getTime();
                            that.total = total;
                            that.updatedData = [].concat(data);
                            that.gridData = data;
                            this.loader = false;
                        } else {
                            this.forceComputedUpdatex1 = null;
                            this.loader = false;
                        }
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            getDataSportlerfreigaben: function (initial) {
                this.forceComputedUpdatex2 = null;
                console.log("---->", initial);
                const that = this;
                this.loaderSportlerfreigaben = true;

                fetch(
                    this.baseUrlSportlerfreigaben,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex2 = new Date().getTime();
                            that.totalSportlerfreigaben = total;
                            that.gridDataSportlerfreigaben = data;
                            this.loaderSportlerfreigaben = false;
                        } else {
                            this.forceComputedUpdatex2 = null;
                            this.loaderSportlerfreigaben = false;
                        }
                    })
                    .finally(() => {
                        this.loaderSportlerfreigaben = false;
                    });
            },
            getDataVereine: function (initial) {
                this.forceComputedUpdatex3 = null;
                console.log("---->", initial);
                const that = this;
                this.loaderVereine = true;

                fetch(
                    this.baseUrlVereine,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex3 = new Date().getTime();
                            that.totalVereine = total;
                            that.gridDataVereine = data;
                            that.filteredGridDataVereine = data;
                            this.loaderVereine = false;
                        } else {
                            this.forceComputedUpdatex3 = null;
                            this.loaderVereine = false;
                        }
                    }).finally(() => {
                        this.loaderVereine = false;
                    });
            },
            filterChange(event) {
                const filterValue = event.target.value.toLowerCase();
                this.filteredGridDataVereine = this.gridDataVereine.filter(obj => {
                    return obj.nameStadtVerein.toLowerCase().includes(filterValue)
                });
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            }
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
